export default "__VITE_ASSET__ca49f6e2__"